import React, { useRef, useEffect, useState } from "react";
import { Form } from "react-bootstrap";
import moment from "moment";
import PropTypes from "prop-types";
import { DatePicker } from "antd";

const { RangePicker } = DatePicker;

function useOutsideClick(ref, callback) {
    useEffect(() => {
        /**
         * Alert if clicked on outside of element
         */
        function handleClickOutside(event) {
            if (
                (ref.current && !ref.current.contains(event.target))
                && !document.getElementsByClassName("ant-calendar-picker-container")[0]
            ) {
                callback(event);
            }
        }

        // Bind the event listener
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            // Unbind the event listener on clean up
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [ref]);
}

const DraftFiltersServiceConfirmation = (props) => {
    const format = "YYYY-MM-DD";

    const {
        onChange,
        // filterObj,
        valuesObj,
        label
    } = props;

    const values = {
        byDate: "By Date",
        confirmedWithoutDate: "Confirmed Without Date",
        notConfirmed: "Not Confirmed",
    };

    const [showDropdown, setShowDropdown] = useState(false);
    const [value, setValue] = useState("");
    const [date, setDate] = useState([null, null]);

    const wrapperRef = useRef(null);
    useOutsideClick(wrapperRef, () => {
        setShowDropdown(false);
    });

    const handleSet = (set) => {
        if (set) {
            onChange({
                fromDate: value === values.byDate && date
                    ? moment(date[0]).format(format)
                    : null,
                toDate: value === values.byDate && date
                    ? moment(date[1]).format(format)
                    : null,
                confirmedWithoutDate: value === values.confirmedWithoutDate || null,
                notConfirmed: value === values.notConfirmed || null
            });
        } else {
            setValue("");
            onChange({
                fromDate: null,
                toDate: null,
                confirmedWithoutDate: null,
                notConfirmed: null
            });
        }
        setShowDropdown(false);
    };

    let inputValue = "";
    if (valuesObj && value !== "") {
        inputValue = value;
        if (value === values.byDate && date[0] && date[1]) {
            if (date[0] && date[1]) {
                inputValue = `${moment(date[0]).format(format)} - ${moment(date[1]).format(format)}`;
            }
        }
    }

    return (
        <Form.Group className="mb-1 draft-filter-wrapper position-relative" ref={wrapperRef}>
            <Form.Label className="mb-0 font-weight-bold">{label}</Form.Label>
            <div className="d-block">
                <input
                    type="text"
                    className="form-control"
                    onFocus={() => setShowDropdown(true)}
                    value={inputValue}
                    readOnly={true}
                />
            </div>

            {!showDropdown ||
            <div
                className="position-absolute border bg-light border-secondary p-2"
                style={{ width: 260 }}
            >
                <div className="form-check">
                    <input
                        className="form-check-input"
                        type="radio"
                        name="serviceType"
                        id="service-by-date"
                        value={values.byDate}
                        onChange={() => setValue(values.byDate)}
                        checked={value === values.byDate}
                    />
                    <label
                        className="form-check-label"
                        htmlFor="service-by-date"
                    >
                        By Date
                    </label>
                </div>

                {value !== values.byDate ||
                <div className="form-group mt-2">
                    <RangePicker
                        className="g-ant-input-no-padding"
                        value={date}
                        format={format}
                        onChange={date => setDate(date)}
                        allowClear={false}
                    />
                </div>
                }

                <div className="form-check">
                    <input
                        className="form-check-input"
                        type="radio"
                        name="serviceType"
                        id="service-without-date"
                        value={values.confirmedWithoutDate}
                        onChange={() => setValue(values.confirmedWithoutDate)}
                        checked={value === values.confirmedWithoutDate}
                    />
                    <label
                        className="form-check-label"
                        htmlFor="service-without-date"
                    >
                        Confirmed without Date
                    </label>
                </div>

                <div className="form-check">
                    <input
                        className="form-check-input"
                        type="radio"
                        name="serviceType"
                        id="service-not-confirmed"
                        value={values.notConfirmed}
                        onChange={() => setValue(values.notConfirmed)}
                        checked={value === values.notConfirmed}
                    />
                    <label
                        className="form-check-label"
                        htmlFor="service-not-confirmed"
                    >
                        Not Confirmed
                    </label>
                </div>

                <div className="text-right">
                    <button
                        className="btn btn-default ml-2"
                        onClick={() => handleSet(false)}
                    >
                        Clear
                    </button>
                    <button
                        className="btn btn-success ml-2"
                        onClick={() => handleSet(true)}
                        disabled={(values.byDate === value && date[0] === null) || value === ""}
                    >
                        Set
                    </button>
                </div>
            </div>
            }
        </Form.Group>
    );
};

DraftFiltersServiceConfirmation.propTypes = {
    label: PropTypes.string.isRequired,
    filterObj: PropTypes.oneOfType([
        PropTypes.object,
        PropTypes.array
    ]).isRequired,
    valuesObj: PropTypes.any.isRequired,
    isMulti: PropTypes.bool.isRequired,
    onChange: PropTypes.func.isRequired,
    isClearable: PropTypes.bool
};

export default DraftFiltersServiceConfirmation;
